<template>
  <b-container fluid>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>

    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>

    <TablaEsteroides
        :items.sync="movimientoService.data"
        :fields.sync="movimientoService.fieldsReembolsoPorEstatus">

      <template v-slot:cell(monto)="row">
        {{ row.item.aFavor ? row.item.monto : row.item.monto * -1 | moneda }}
      </template>

      <template v-slot:cell(diasSolucion)="row">
        <b-badge :variant="obtenerDiasParaResolver(row) > 0 ? 'info':'warning'">{{
            obtenerDiasParaResolver(row)
          }}
        </b-badge>
      </template>
      <template v-slot:cell(saldoTotal)="{item}">
        {{ item.saldoTotal | moneda }}
      </template>
      <template v-slot:cell(detalle)="row">
        <b-button
            v-b-modal="'detalle-'+row.item.idMovimiento"
            size="sm"
            variant="info"
        >
          <font-awesome-icon
              icon="eye"
          />
        </b-button>
        <b-modal
            size="lg"
            ok-title="Aceptar"
            cancel-title="Cerrar"
            :id="'detalle-'+row.item.idMovimiento" title="Detalle del movimiento">
          <div>
            <b-tabs content-class="mt-3">
              <b-tab title="Detalle" active>
                <p class="my-4">
                  <DetalleMovimiento :fields="movimientoService.fieldsMovimientoDetalle" :movimiento="row.item"/>
                </p>
              </b-tab>
              <b-tab title="Tratamientos">
                <p class="my-4">
                  <DetalleTratamientosReembolsados :movimiento="row.item"></DetalleTratamientosReembolsados>
                </p>
              </b-tab>
              <b-tab title="Cuestionario Legal">
                <p class="my-4">
                  <FormCuestionarioLegal :cuestionario="row.item.cuestionarioLegal" :desdeLista="desdeLista"></FormCuestionarioLegal>
                </p>
              </b-tab>
            </b-tabs>
          </div>
        </b-modal>
      </template>
      <template v-slot:cell(aceptarMovimiento)="row" v-if="$localStorageService.can('MV_ch_estatus_aceptado')">
        <b-button
            size="sm"
            :disabled="itemEnEstatusFinal(row.item)"
            :variant="itemEnEstatusFinal(row.item) ? 'secondary': 'success'"
            v-on:click="cambiarEstatusAceptado(row)"
        >
          <font-awesome-icon
              icon="check"
          />
        </b-button>
      </template>
      <template v-slot:cell(rechazarMovimiento)="row" v-if="$localStorageService.can('MV_ch_estatus_rechazado')">
        <b-button
            size="sm"
            :disabled="itemEnEstatusFinal(row.item)"
            :variant="itemEnEstatusFinal(row.item) ? 'secondary': 'danger'"
            v-on:click="cambiarEstatusRechazado(row)"
        >
          <font-awesome-icon
              icon="times"
          />
        </b-button>
      </template>
      <template v-slot:cell(autorizaciones)="row">
        <b-button
            v-b-modal="'autorizar-'+row.item.idMovimiento"

            :disabled="itemEnEstatusFinal(row.item)"
            :variant="itemEnEstatusFinal(row.item) ? 'secondary': usuarioAutorizaMovimiento(row.item.autorizaciones)? 'info':'secondary'"
        >
          <font-awesome-icon
              :icon="autorizacionesCompletas(row.item.autorizaciones) ? 'check':'eye'"
          />
        </b-button>
        <b-modal
            ok-title="Aceptar"
            cancel-title="Cerrar"
            size="lg"
            :id="'autorizar-'+row.item.idMovimiento" title="Autorización del movimiento">
          <p class="my-4">
            <AutorizarMovimientoConComentario :autorizaciones="row.item.autorizaciones"></AutorizarMovimientoConComentario>
          </p>
        </b-modal>
      </template>
      <template v-slot:cell(archivos)="row">
        <b-button v-b-modal="'archivos-'+row.item.idMovimiento" size="sm">
          <font-awesome-icon icon="file"/>
        </b-button>
        <b-modal
            ok-title="Aceptar"
            cancel-title="Cerrar"
            size="lg"
            :id="'archivos-'+row.item.idMovimiento" title="Archivos del movimiento">
          <p class="my-4">
            <ListarYSubirArchivos
                :show-delete="false"
                :archivos="row.item.archivos"
                :paciente="row.item.idPaciente"
                :padre="'reembolso'"
                :idMovimiento="row.item.idMovimiento"
                :estatus="estatus"
            />
          </p>
        </b-modal>
      </template>

      <template v-slot:cell(pdf)="row">

        <MostrarComprobanteMovimiento v-if="row.item.fechaSolucion !== null" :id-movimiento="row.item.idMovimiento"/>
        <div v-else class="text-info">No se ha completado el proceso</div>
      </template>

      <template v-slot:cell(notaCredito)="row" v-if="$localStorageService.can('RE_nota_credito')">
        <label style="font-size: small">Selecciona una factura:</label>
        <v-select style="width: 100%; font-size: small" :options="row.item.facturas"
                  v-model="row.item.facturaSeleccionada"
                  label="factura" placeholder="Selecciona una factura">
          <span slot="no-options">No hay facturas para el recibo.</span>
        </v-select>
        <b-button v-if="row.item.facturas.length > 0" class="mt-2" size="sm"
                  variant="outline-info" @click="generarNotaCredito(row.item)">
          Generar Nota de Crédito
        </b-button>
      </template>

    </TablaEsteroides>
  </b-container>
</template>

<script>
import MostrarComprobanteMovimiento from "@/views/movimientos/movimiento/MostrarComprobanteMovimiento";
import DetalleMovimiento from "@/views/movimientos/movimiento/DetalleMovimiento";
import TablaEsteroides from "@/components/tablaConEsteroides/TablaEsteroides";
import {MovimientoService} from "@/apiServices/movimiento/MovimientoService";
import FormCuestionarioLegal from "@/views/movimientos/reembolso/FormCuestionarioLegal";
import DetalleTratamientosReembolsados from "@/views/movimientos/reembolso/DetalleTratamientosReembolsados";

import AutorizarMovimientoConComentario from "@/views/movimientos/movimiento/AutorizarMovimientoConComentario";

import ListarYSubirArchivos from "@/views/movimientos/ListarYSubirArchivos";
import {FacturacionService} from "@/apiServices/facturacion/FacturacionService";


export default {
  name: "ListaReembolsosPorEstatus",
  components: {

    ListarYSubirArchivos,
    DetalleTratamientosReembolsados,
    FormCuestionarioLegal,
    MostrarComprobanteMovimiento, AutorizarMovimientoConComentario, DetalleMovimiento, TablaEsteroides
  },
  props: {
    estatus: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,

      movimientoService: new MovimientoService(),
      facturacionService: new FacturacionService(),
      desdeLista: true,
      idFactura: null
    }
  },
  methods: {

    itemEnEstatusFinal(item) {
      return item.idEstatusMovimiento === 4 || item.idEstatusMovimiento === 5;
    },
    cambiarEstatusAceptado(row) {

      this.$swal.fire({
        title: "¿Desea Aceptar el Movimiento?",
        icon: "danger ",
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
        showLoaderOnConfirm: true,
        preConfirm: (confirm) => {
          if (confirm)
            this.movimientoService.cambiarEstatusAceptado(row.item.idMovimiento).then(() => {
              this.movimientoService.listarMovimientos({estatusMovimiento: this.estatus});
            })
        },
        allowOutsideClick: () => !this.$swal.isLoading(),
      });

    },
    cambiarEstatusRechazado(row) {
      this.$swal.fire({
        title: "¿Desea Rechazar el Movimiento?",
        icon: "danger ",
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
        showLoaderOnConfirm: true,
        preConfirm: (confirm) => {
          if (confirm)
            this.movimientoService.cambiarEstatusRechazado(row.item.idMovimiento).then(() => {
              this.movimientoService.listarMovimientos({estatusMovimiento: this.estatus});
            })
        },
        allowOutsideClick: () => !this.$swal.isLoading(),
      });


    },
    obtenerDiasParaResolver({item}) {
      const dias = item.diasSolucion;
      const d1 = new Date(item.fechaAlta)
      const d2 = new Date(d1)
      d2.setDate(d2.getDate() + dias)
      const d3 = new Date();
      return this.movimientoService.formatters.date.diasDiferencia(d3, d2);
    },
    usuarioAutorizaMovimiento(autorizaciones) {
      return !!autorizaciones.find(autorizacion => autorizacion.idEmpleado === this.$localStorageService.getIdEmpleado())
    },
    autorizacionesCompletas(autorizaciones) {
      return !autorizaciones.find(autorizacion => autorizacion.autorizado === false)
    },
    generarNotaCredito(item){
      if (item.facturaSeleccionada === null){
        this.$swal({
          icon: "error",
          text: "Debes seleccionar una Factura para poder generar la Nota de Crédito.",
          confirmButtonText: "OK",
          confirmButtonColor: "#0e6ba9",
        });
        return false;
      } else {
        this.facturacionService.generarNotaCredito(item.idRecibo, item.facturaSeleccionada);
      }
    }
  },
  async created() {
    this.debug = this.$localStorageService.getDebug();

    this.movimientoService.listarReembolsos({estatusMovimiento: this.estatus});
    this.$root.$on('reload-reembolsos', async (estatus) => {
      if (estatus === this.estatus || estatus === 'force') {
        this.movimientoService.listarReembolsos({estatusMovimiento: this.estatus});
      }
    })
  },
  computed: {
    isLoading() {
      return this.movimientoService.loading;
    }
  }
}
</script>

<style scoped>

</style>
